<template>
  <div
    v-if="email || phone"
    class="contact-details"
  >
    <div
      v-if="email"
      class="contact-details__item"
    >
      <div>
        <icon-email />
        <a
          :href="`mailto: ${email}`"
          class="text-body-s-regular contact-details__text"
          v-text="email"
        />
      </div>
      <a
        :data-value="email"
        class="contact-details__copy"
        @click="copy(email, 'email')"
      >
        <icon-copy />
        <span
          class="text-body-xs-regular tooltip"
          :class="{ 'active': showTooltip.email }"
          v-text="$string('general.find_rep.copied_tooltip')"
        />
      </a>
    </div>
    <div
      v-if="phone"
      class="contact-details__item"
    >
      <div>
        <icon-phone />
        <a
          :href="`tel: ${phone}`"
          class="text-body-s-regular contact-details__text"
          v-text="phone"
        />
      </div>
      <a
        :data-value="phone"
        class="contact-details__copy"
        @click="copy(phone, 'phone')"
      >
        <icon-copy />
        <span
          class="text-body-xs-regular tooltip"
          :class="{ 'active': showTooltip.phone }"
          v-text="$string('general.find_rep.copied_tooltip')"
        />
      </a>
    </div>
  </div>
</template>

<script>

/**
 * Vue: Contact details (contact-details)
 * -----------------------------------------------------------------------------
 * Contact Details (Email & Phone).
 *
 * @param {String} email - Contact email.
 * @param {String} phone - Contact phone.
 *
 */

import IconEmail from '~icons/general/email.svg'
import IconPhone from '~icons/general/phone.svg'
import IconCopy from '~icons/general/copy.svg'

export default {
  name: 'ContactDetails',

  components: {
    IconEmail,
    IconPhone,
    IconCopy,
  },

  props: {
    email: {
      type: String,
      default: () => '',
    },
    phone: {
      type: String,
      default: () => '',
    },
  },

  data() {
    return {
      showTooltip: {
        email: false,
        phone: false,
      },
    }
  },

  methods: {

    /**
     * Handles copy to clipboard event.
     * @param {String} text - Text to copy.
     * @param {String} key - Copy element key.
     */
    copy(text, key) {

      navigator.clipboard.writeText(text)
      this.showTooltip[key] = true

      setTimeout(() => {
        this.showTooltip[key] = false
      }, 2000)
    },
  },
}
</script>

<style lang="scss">
@import './contact-details';
</style>
